import React, { createContext, useContext, useState, ReactNode } from 'react';
import { translations, Translations } from '../translations';

interface LanguageContextType {
  language: string;
  t: Translations;
  switchLanguage: (lang: string) => void;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

interface LanguageProviderProps {
  children: ReactNode;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const [language, setLanguage] = useState('en');
  
  const switchLanguage = (lang: string) => {
    setLanguage(lang);
  };
  
  const t = translations[language];
  
  return (
    <LanguageContext.Provider value={{ language, t, switchLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};